import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-DAY WEIGHT LOSS CHALLENGE',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40–49',
					img: require('@/assets/landing-activity-female/activity-senior-f-40.webp'),
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50-59',
					img: require('@/assets/landing-activity-female/activity-senior-f-50.webp'),
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: 'Age: 60-69',
					img: require('@/assets/landing-activity-female/activity-senior-f-60.webp'),
				},
				{
					value: 70,
					analyticValue: '70+',
					label: 'Age: 70-80',
					img: require('@/assets/landing-activity-female/activity-senior-f-70.webp'),
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
